import React from 'react';

import { BlockContainer } from './style';

const BlockWrapper = ({ title, children, secondaryContent }) => {
    return (
        <BlockContainer>
            <div className="title-wrapper">
                <div className="title">{title}</div>
                {secondaryContent ? <div>{secondaryContent}</div> : null}
            </div>
            <div>{children}</div>
        </BlockContainer>
    )
}

export default BlockWrapper;
